<template>
    <div>

        <div v-if="loading">
            <a-spin tip="Loading...">
                <div class="spin-content">
                    กรุณารอสักครู่
                </div>
            </a-spin>
        </div>
        <div v-else id="appMain">
            <div class="container-sm">

                <div>
                    <a-divider>รายการฝากสำเร็จ</a-divider>
                </div>
                <div class="row">
                    <div class="col-12 col-md-12 col-lg-12">
                        <div class="card p-2">
                            <a-card title="ข้อมูลบัญชีลูกค้า" bordered>
                                <!-- <a-button slot="extra" icon="copy" href="#" @click="copyBookMember()">คัดลอก</a-button> -->

                                <div class="d-flex flex-row">
                                    <div class="box-img rounded" :style="`background-color: ${data.bankUser_background};`"><img width="100%" :src="`${data.bankUser_icon}`" alt=""></div>
                                    <div class="d-flex flex-column pl-3">
                                        <span>ชื่อบัญชี : {{ data.bankUser_accountName }}</span>
                                        <span>เลขบัญชี : <b id="member-book-number">{{ data.bankUser_accountNumber }}</b></span>
                                        <span>ธนาคาร : {{ data.bankUser_shortName }}</span>
                                    </div>
                                </div>
                            </a-card>
                            <div class="d-flex justify-content-center align-items-center py-1">
                                <div class="arrow bounce">
                                <a class="fa fa-arrow-down fa-2x" href="#"></a>
                                </div>
                            </div>
                            <a-card title="ข้อมูลบัญระบบ" bordered>
                                <a-button slot="extra" icon="copy" type="primary" href="#" @click="copyBookSystem()">คัดลอก</a-button>

                                <div class="d-flex flex-row">
                                    <div class="box-img rounded" :style="`background-color: ${data.bankService_background};`"><img width="100%" :src="`${data.bankService_icon}`" alt=""></div>
                                    <div class="d-flex flex-column pl-3">
                                        <span>ชื่อบัญชี : {{data.bankService_accountName}}</span>
                                        <span>เลขบัญชี :  <b id="system-book-number">{{data.bankService_accountNumber}}</b></span>
                                        <span>ธนาคาร : {{ data.bankService_shortName }}</span>
                                    </div>
                                </div>
                            </a-card>
                        </div>
                    </div>
                </div>
                <div class="card p-2">
                    <a-card :title="`รายละเอียดการฝาก`">
                        <div class="row">
                            <div class="col-12 col-md-12 col-lg-12">
                            <div class="w-100 rounded text-center text-success p-3">
                                <span class="h1 font-weight-bold">
                                    {{data.sumAmount}} ฿
                                </span>
                            </div>
                            <div class="text-center">
                                <small class="text-center text-danger">หมดอายุอีกใน (60 วินาที)</small>
                            </div>
                            </div>
                            <div class="col-12 col-md-12 col-lg-12">
                                <div class="row">
                                    <div class="col-12 col-md-12 col-lg-12">
                                        <b-badge  variant="success" class="w-100" pill>
                                            <div class="d-flex flex-row justify-content-between">
                                                <small>#{{ data.depositCode }}</small>
                                                <small>{{ data.createdAt }}</small>
                                            </div>

                                        </b-badge>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </a-card>

                </div>
            </div>
        </div>
    </div>
  </template>
<script>
import apiClient from '@/services/api'
export default {
  data () {
    return {
      loading: false,
      data: {},
    }
  },
  methods: {
    async getData() {
      this.loading = !this.loading
      const depositCode = this.$route.params.depositCode
      await apiClient.get(`/deposit/public/getTransaction/${depositCode}`).then(response => {
        this.loading = !this.loading
        const res = response.data

        if (res.code === '000') {
          this.data = res.responseData.data[0]
        }
      })
    },
    copyBookMember () {
      const memberBookNumber = document.getElementById('member-book-number').textContent
      navigator.clipboard.writeText(memberBookNumber).then(() => {
        this.openNotification()
      })
    },
    copyBookSystem () {
      const systemBookNumber = document.getElementById('system-book-number').textContent
      navigator.clipboard.writeText(systemBookNumber).then(() => {
        this.openNotification()
      })
    },
    openNotification() {
      this.$notification.open({
        message: 'คัดลอกสำเร็จ',
        icon: <a-icon type="smile" style="color: green" />,
      })
    },
  },
  async created () {
    await this.getData()
  },
}
</script>
<style>
body {
    background: rgb(246, 246, 246);
}
.box-img {
    width: 80px;
}
span {
    font-size: 1.2em;
    color: bl;
}
.arrow {
  text-align: center;
  margin: 8% 0;
}
.bounce {
  -moz-animation: bounce 2s infinite;
  -webkit-animation: bounce 2s infinite;
  animation: bounce 2s infinite;
}

@keyframes bounce {
  0%, 20%, 50%, 80%, 100% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(-30px);
  }
  60% {
    transform: translateY(-15px);
  }
}
</style>
